import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { getBrandImage } from '@utils/get-brand-image.ts';
import { getBrandName } from '@utils/get-brand-name.ts';

import { Button } from '@components/button';

import { config } from '@/config.ts';

import * as Styled from './promo.styled.ts';

const getBannerBgKey = (isCom2: boolean, language: string) => {
	if (!isCom2) {
		return 'bannerBg';
	}
	if (language === 'en') {
		return 'bannerBgEn';
	}
	if (language === 'ru') {
		return 'bannerBgRu';
	}

	return 'bannerBg';
};

const Promo = () => {
	const { t, i18n } = useTranslation('promo');
	const promoImage = getBrandImage('promo');
	const brandName = getBrandName();
	const isCom2 = config.BRAND === 'com2';

	const bannerBgKey = getBannerBgKey(isCom2, i18n.language);

	const bannerBg = getBrandImage(bannerBgKey);
	const bannerBgMob = getBrandImage('bannerBgMob');

	return (
		<Styled.Wrapper>
			<Styled.Section>
				<Styled.Title>
					{t('title1', { brandName })} {t('title1_hg', { brandName })}
				</Styled.Title>
				<Styled.Banner $bannerBg={bannerBg} $bannerBgMob={bannerBgMob} $isCom2={isCom2}>
					<Styled.Info>
						<Styled.BannerTitle>{t('title2')}</Styled.BannerTitle>
						<Styled.BannerTitle>{t('title2_hg')}</Styled.BannerTitle>
						<Styled.Tags>
							<Styled.Tag>{t('patch1')}</Styled.Tag>
							<Styled.Tag>{t('patch2')}</Styled.Tag>
							<Styled.Tag>{t('patch3')}</Styled.Tag>
						</Styled.Tags>

						<NavLink to='/quests'>
							<Button color='primary' size='large' minWidth={104}>
								{t('quests')}
							</Button>
						</NavLink>
					</Styled.Info>

					<Styled.BannerImg src={promoImage} />
				</Styled.Banner>
			</Styled.Section>
		</Styled.Wrapper>
	);
};

export default Promo;
